module.exports = __webpack_public_path__ + "img/giaotannoi.9edf23cc.png";